import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Text,
  Typography,
} from '@maas-components/core'
import { PersonOutline } from '@maas-components/icons'
import useStyles from '../style'

interface UserInfoProps {
  name: string
  email: string
  description: string
}

export default function Index({ name, email, description }: UserInfoProps) {
  const classes = useStyles()
  return (
    <ListItem alignItems="flex-start" className={classes.avatarListItem}>
      <ListItemAvatar>
        <Avatar alt={name} className={classes.avatarUserInfo}>
          <PersonOutline fontSize="large" />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        style={{ marginLeft: 16 }}
        primary={
          <Typography
            component="span"
            variant="body1"
            color="textPrimary"
            className={classes.listItemTitle}
          >
            <strong> {name} </strong>
          </Typography>
        }
        secondary={
          <>
            <Typography
              component="span"
              variant="caption"
              color="textSecondary"
              className={classes.listItemTitle}
            >
              <Text fontWeight="regular" fontSize="xsmall">
                {email}
              </Text>
            </Typography>
            <Typography
              component="span"
              variant="caption"
              color="textSecondary"
              className={classes.listItemTitle}
            >
              <Text fontWeight="regular" fontSize="xsmall">
                {description}
              </Text>
            </Typography>
          </>
        }
      />
    </ListItem>
  )
}
